// extracted by mini-css-extract-plugin
module.exports = {"usersTable":"usersTable__y4Pbp","pendingBadge":"pendingBadge__D6Ivk"};